// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"_35U99","registrationWrapper":"_1qgKD"};